import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { EmpresaService } from '@shared/services/empresa.service';
import { ETipoSistemasEmpresa } from '@core/enums/tipoSistemasEmpresa.enum';

/**
 * Guard que verifica si el sistema está activo para la empresa.
 * Recibe los sistemas requeridos como array en la configuración `data`.
 *
 * Uso en rutas:
 *   { path: 'comandas', component: Comandas, canMatch: [sistemaGuard([ETipoSistemasEmpresa.COMANDAS])] }
 */
export function sistemaGuard(sistemasRequeridos: ETipoSistemasEmpresa[]): CanMatchFn {
  return () => {
    const empresaService = inject(EmpresaService);
    const router = inject(Router);

    const empresa = empresaService.getEmpresaData();
    if (!empresa) {
      return true;
    }

    const activos = empresa.sistemas_activos ?? [];
    const tieneAcceso = sistemasRequeridos.some((s) => activos.includes(s));

    if (!tieneAcceso) {
      router.navigate(['/panel/dashboard']);
      return false;
    }

    return true;
  };
}
